import React from 'react'
import styled from '@emotion/styled'
import { graphql, useStaticQuery, Link } from 'gatsby'

import monogramSrc from '../img/visa-kings-global-monogram-light.svg'

export default function FooterDisclaimer() {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          registeredCompany {
            name
          }
        }
      }
    }
  `)
  const { registeredCompany } = data.site.siteMetadata

  return (
    <FooterDisclaimerWrapper>
      <div className="container">
        <div className="regulatoryWrapper">
          <div className="legalText">
            <p>
              The brand name Visa Kings Global is used under licence by{' '}
              {registeredCompany.name}. {registeredCompany.name} is not a firm
              of solicitors and is not regulated by the Solicitors Regulation
              Authority. {registeredCompany.name} does not give financial, legal
              or tax advice.
            </p>
            <p>
              Information affecting all users of this website can be found on
              our <Link to="/legal-notices/">Legal Notices</Link> page which you
              are deemed to have read and accepted.
            </p>
          </div>
        </div>
      </div>
      <img
        className="monogram"
        src={monogramSrc}
        alt="Visa Kings Global Monogram"
        width="500"
        height="344"
        style={{ height: 32, width: 'auto' }}
        loading="lazy"
      />
    </FooterDisclaimerWrapper>
  )
}

const FooterDisclaimerWrapper = styled.div`
  background: #fff;

  .monogram {
    margin-left: auto;
    margin-right: auto;
    margin-top: 24px;
    margin-bottom: 60px;
    filter: brightness(0);
    opacity: 0.1;
  }

  .regulatoryWrapper {
    background: #fff;
    padding-top: 24px;
    padding-bottom: 24px;
    font-size: 1.5rem;

    .legalText {
      max-width: 460px;
      p {
        margin-top: 0;
      }
    }
  }
`
